var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2305 12.7279C14.6756 13.1717 15.1121 13.6063 15.548 14.0414C16.255 14.7479 16.9641 15.453 17.6671 16.1634C17.9657 16.4647 18.075 16.8279 17.9477 17.2411C17.8251 17.641 17.5478 17.8902 17.1407 17.9762C16.7288 18.0635 16.3943 17.9095 16.1044 17.619C15.0462 16.5566 13.9839 15.4983 12.9257 14.436C12.8617 14.3713 12.8137 14.2907 12.7551 14.2127C10.7818 15.6496 8.6367 16.1608 6.29029 15.6789C4.33507 15.2777 2.76036 14.2434 1.5615 12.6499C-0.776243 9.54156 -0.457036 5.14431 2.30387 2.33988C5.03013 -0.428565 9.43705 -0.790448 12.5858 1.52214C14.3664 2.83039 15.442 4.59115 15.7612 6.78578C16.0784 8.96841 15.534 10.9424 14.2311 12.7279H14.2305ZM7.92298 13.7136C11.1264 13.7142 13.702 11.1457 13.7114 7.94141C13.72 4.72978 11.1417 2.14327 7.92698 2.13994C4.72558 2.13661 2.14727 4.70778 2.13927 7.91209C2.13127 11.1264 4.70958 13.7122 7.92298 13.7129V13.7136Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.89adea2b970a18265891deba278d5f23.svg";
export { ForwardRef as ReactComponent };